import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import { useQuerySnippets } from 'modules/quickActionsMenu/hooks';
import { useRumError } from 'services/observability/datadog';
import { Product, Team } from 'teams';

export const useSnippetSearch = () => {
  const { debouncedSearchTerm } = useQuickActionsMenuContext();
  const addErrorSignal = useRumError();

  const { isLoading, data } = useQuerySnippets(debouncedSearchTerm, {
    onError: (error) => {
      addErrorSignal(error, 'QuickActionsMenu > useSnippetSearch', {
        name: 'Quick Actions Menu snippets GraphQL query',
        productName: Product.SNIPPETS,
        teamName: Team.CONTENT_TEAM,
      });
    },
  });

  const { paginationInfo, results: snippets = [] } = data?.fetchSnippets || {};

  return { paginationInfo, isLoading, snippets };
};
